module.exports = __webpack_public_path__ + "img/Nouveau.5b929661.png";